interface InsurerProperty {
  name?: string;
  enum?: string[];
}

interface RawInsurer {
  readonly __typename?: "MinInsuranceProvider";
  readonly id: string;
  readonly name?: string;
  readonly insuranceType?: string;
  readonly properties?: readonly unknown[];
}

// Mirrors the existing helpers in TabContentOnline / TabContentRxdb: the
// `dependent` property arrives lower-cased from api-insurance but the rest
// of the app uses the upper-cased Dependent gql enum. Normalising here keeps
// the cast localised.
export const capitaliseDependentsEnum = (
  minInsuranceProviders: readonly RawInsurer[],
) =>
  minInsuranceProviders.map((i) => ({
    ...i,
    properties: i.properties?.map((p) => {
      const property = p as InsurerProperty;
      if (property.name === "dependent") {
        return {
          ...property,
          enum: property.enum?.map((e: string) => e.toUpperCase()),
        };
      }
      return property;
    }),
  }));
